import React, { useState, useEffect } from 'react';
import './index.scss';
import zuojiantou from '../../img/zuojiantou.png';
import yinhao from '../../img/yinhao.png';
import BuyBtn from '../BuyBtn';
import { useNavigate } from 'react-router-dom';
import { IMGURL } from 'lib/config';
import LazyImg from 'common/components/LazyImg';
import QueueAnim from 'rc-queue-anim';
import { OverPack } from 'rc-scroll-anim';

type JingxuanProps = {
  jingxuan: any;
};
const RecommendProduct: React.FC<JingxuanProps> = ({ jingxuan }) => {
  const navigate = useNavigate();
  const { groups, moreButton, tagText, title } = jingxuan;
  const [serial, setSerial] = useState(0);
  const [isScroll, setIsScroll] = useState(false);
  const handleToJump = (num: any) => {
    setSerial(num);
  };
  useEffect(() => {
    // window.addEventListener("scroll", function () {
    //   const scrollTop =
    //     document.documentElement.scrollTop || document.body.scrollTop;
    //   if (scrollTop > 0) {
    //     setIsScroll(true);
    //   }
    //   console.log(scrollTop, "是什么");
    setTimeout(() => {
      setIsScroll(true);
    }, 500);
    // });
  }, []);
  return (
    <div className='relection_recommend_wrap'>
      <div className='relection_recommend' key='recommend'>
        <div className='commend_title' key='title'>
          <div className='title_left'>
            <div className='commend_bigTit'>{title}</div>
            {/* <div className="des">专业之上 更加用心</div> */}
          </div>
          <div className='title_right'>
            {tagText.split('|').map((str: string, index: number) => (
              <span className='title_right_tag' key={index}>
                {str}
              </span>
            ))}
          </div>
        </div>

        <OverPack
          style={{ height: '690px' }}
          playScale={0.1}
          // @ts-ignore
          always={false}
          appear={isScroll}
        >
          <QueueAnim key='queue' type={'bottom'} delay={100} duration={600}>
            <div className='kind' key='kind'>
              <div className='kind_all noselect'>
                {groups.map((item: any, index: any) => (
                  <div
                    key={index}
                    className={
                      index === serial ? '_product_for' : 'product_for'
                    }
                    onClick={() => handleToJump(index)}
                    onMouseEnter={() => {
                      handleToJump(index);
                    }}
                  >
                    {item.group}
                  </div>
                ))}
              </div>
              <div
                className='more'
                onClick={() => {
                  navigate('/bxsc/all');
                }}
              >
                <div className='more_mesg'>{moreButton.buttonShow[0]}</div>
                <div className='more_img'>
                  <img src={zuojiantou} alt='' />
                </div>
              </div>
            </div>
            <div className='desc' key='desc'>
              <div className='desc_img'>
                <img src={yinhao} alt='' />
              </div>
              <div className='desc_mesg'>{groups[serial].desc}</div>
            </div>
            <div className='recommend' key='recommend'>
              {groups[serial].products.map((item: any, index: any) => (
                <div className='recommend_product' key={index}>
                  <div className='recomend_img'>
                    <LazyImg src={`${IMGURL}${item.display.icon}`} alt={item.display.name} />
                  </div>
                  <div className='product_info'>
                    <h1 className='product_name'>{item.display.name}</h1>
                    <div className='product_description'>
                      {item.display.feature}
                    </div>
                    <div className='product_operation'>
                      <div className='product_price '>
                        <div className='price'>{item.display.premium}</div>
                        &nbsp;
                        <div className='price_start'>
                          {item.display.premium2}
                        </div>
                      </div>
                      <BuyBtn link={item.link} />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </QueueAnim>
        </OverPack>
      </div>
    </div>
  );
};

export default RecommendProduct;
